import { Pipe, PipeTransform } from '@angular/core';
import { RemittanceStatus } from '../../../models/remittances/remittance-status';
import { StatusPill } from '../../../models/shared/status-pill';
import { RemittanceStatusPill } from '../../../models/shared/remittance-status-pill';

@Pipe({
  name: 'remittanceStatusPill',
  standalone: true
})
export class RemittanceStatusPillPipe implements PipeTransform {
  transform(status: RemittanceStatus): StatusPill {
    return new RemittanceStatusPill(status.id, status.name);
  }
}
